/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
( function() {
	const siteNavigation = document.getElementById( 'site-navigation' );

	// Return early if the navigation doesn't exist.
	if ( ! siteNavigation ) {

		return;
	}

	const button = document.getElementById( 'mobile-toggle' );

	// Return early if the button doesn't exist.
	if ( 'undefined' === typeof button ) {
		console.log('no site nav toggle!');
		return;
	}

	const menu = document.getElementById( 'primary-menu' );

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';

		return;
	}

	if ( ! menu.classList.contains( 'nav-menu' ) ) {
		menu.classList.add( 'nav-menu' );
	}

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener( 'click', function() {
		siteNavigation.classList.toggle( 'toggled' );

		if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
			button.setAttribute( 'aria-expanded', 'false' );
		} else {
			button.setAttribute( 'aria-expanded', 'true' );
		}

		var height=window.innerHeight + menu.offsetTop;
		//menu.style.minHeight=height+'px'; //2024-02-12 MDP stop calculating min-height to allow scroll

	} );

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener( 'click', function( event ) {
		const isClickInside = siteNavigation.contains( event.target );
		const isClose=event.target.classList.contains('close-nav');
		if ( ! isClickInside || isClose ) {
			siteNavigation.classList.remove( 'toggled' );
			button.setAttribute( 'aria-expanded', 'false' );
		}
	} );

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName( 'a' );

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

	// Toggle focus each time a menu link is focused or blurred.
	for ( const link of links ) {
		link.addEventListener( 'focus', toggleFocus, true );
		link.addEventListener( 'blur', toggleFocus, true );
		link.addEventListener('click', closeMenu, true)
	}

	// Toggle focus each time a menu link with children receive a touch event.
	for ( const link of linksWithChildren ) {
		link.addEventListener( 'touchstart', toggleFocus, false );
	}

	function closeMenu(){

		if(!jQuery(this).parent().hasClass('menu-item-has-children')) {
			siteNavigation.classList.remove('toggled');
		}
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		return;
		if ( event.type === 'focus' || event.type === 'blur' ) {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while ( ! self.classList.contains( 'nav-menu' ) ) {
				// On li elements toggle the class .focus.
				if ( 'li' === self.tagName.toLowerCase() ) {
					self.classList.toggle( 'focus' );
				}
				self = self.parentNode;
			}
		}

		if ( event.type === 'touchstart' ) {
			const menuItem = this.parentNode;
			event.preventDefault();
			for ( const link of menuItem.parentNode.children ) {
				if ( menuItem !== link ) {
					link.classList.remove( 'focus' );
				}
			}
			menuItem.classList.toggle( 'focus' );
		}
	}
}() );


jQuery(document).ready(function($){
	let touchStartY;
	let touchEndY;
	$('#primary-menu > li > a').on('touchstart',function(e){
		touchStartY = e.touches[0].clientY;
	});
	$('#primary-menu > li > a').on('touchmove',function(e){
		touchEndY = e.touches[0].clientY;
	});
	$('#primary-menu > li > a').on('touchend',function(e){
		const deltaY = touchEndY - touchStartY;

		// If deltaY is less than a threshold, it is considered a click
		if (Math.abs(deltaY) < 10) {
			expandNav(e, this);
		}
	});
	$('#primary-menu > li.menu-item-has-children > a').on('click',function(e){
		expandNav(e,this);
	});
	function expandNav(e,element){
		if(window.innerWidth > 1024) return true;
		e.preventDefault();
		var $this=$(element);
		var $parent=$this.parent('li');
		$('#primary-menu > li').removeClass('expanded');
		$parent.addClass('expanded');
		$('#primary-menu').addClass('has-expanded');
	}

	$('.primary-nav__header:not(:only-child) > a').on('click',function(e){
		var $section=$(this).parents('.primary-nav__section');
		if($section.hasClass('expanded')){ return true; }
		e.preventDefault();
		$('.primary-nav__section').removeClass('expanded');
		$section.addClass('expanded');
	});
	$('.primary-nav__header:not(:only-child) > span').on('click',function(e){
		var $section=$(this).parents('.primary-nav__section');
		e.preventDefault();
		$section.toggleClass('expanded');
	});

	$('.nav-back').on('click',function(e){
		$(this).closest('li.expanded').removeClass('expanded');
		$('#primary-menu').removeClass('has-expanded');
	});

	$('.subnav .title').on('click',function(e){
		if(window.innerWidth<1024){
			e.preventDefault();
			$(this).closest('.subnav').toggleClass('expanded');
		}
	});

	$('.no-head-link').on('click',function(){

	});
});